<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';

@Component({})
export default class CompetenceComponent extends Vue {
  activeTab: 's5' | 's6' = 's5';

  competencesS5 = [
    {
      competence: 1,
      title: "Développement d'Application",
      description: "Réaliser un développement d'application",
      color: '#d08a77',
      icon: 'mdi-code-braces',
      children: [
        {
          code: 'UE1.1',
          description: 'Implémenter des applications informatiques',
          projects: [
            {name: 'Home Lab', url: '/homelab'},
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'PikuTrade', url: '/pikutrade'},
            {name: 'SAE Referendum', url: '/referendum'},
            {name: 'Code Game Jam', url: '/cgj'},
            {name: 'Stage GAGNE', url: '/stage'},
          ]
        },
        {
          code: 'UE3.1',
          description: 'Partir des exigences et aller jusqu\'une application complète',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Stage GAGNE', url: '/stage'}
          ]
        },
        {
          code: 'UE5.1',
          description: 'Adapter des applications sur un ensemble de supports (embarqué, web, mobile, IoT…)',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Stage GAGNE', url: '/stage'}
          ]
        },
      ]
    },
    {
      competence: 2,
      title: "Optimisation",
      description: "Optimiser des applications",
      color: '#ff6f4c',
      icon: 'mdi-rocket-launch-outline',
      children: [
        {
          code: 'UE1.2',
          description: 'Appréhender et construire des algorithmes',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'PikuTrade', url: '/pikutrade'},
            {name: 'SAE Referendum', url: '/referendum'},
            {name: 'Code Game Jam', url: '/cgj'},
            {name: 'Stage GAGNE', url: '/stage'},
          ]
        },
        {
          code: 'UE3.2',
          description: 'Sélectionner les algorithmes adéquats pour répondre à un problème donné',
          projects: [
            {name: 'PikuTrade', url: '/pikutrade'}
          ]
        },
      ]
    },
    {
      competence: 3,
      title: "Administration Système",
      description: "Administrer des systèmes informatiques communicants complexes",
      color: '#fdcf41',
      icon: 'mdi-server-network',
      children: [
        {
          code: 'UE3.3',
          description: 'Déployer des services dans une architecture réseau',
          projects: [
            {name: 'Home Lab', url: '/homelab'},
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'SAE Referendum', url: '/referendum'}
          ]
        },
        {
          code: 'UE5.3',
          description: 'Faire évoluer et maintenir un système informatique communicant en conditions opérationnelles',
          projects: [
            {name: 'Home Lab', url: '/homelab'},
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'SAE Referendum', url: '/referendum'}
          ]
        },
      ]
    },
    {
      competence: 4,
      title: "Gestion des Données",
      description: "Gérer des données de l'information",
      color: '#91ae4f',
      icon: 'mdi-database',
      children: [
        {
          code: 'UE1.4',
          description: 'Concevoir et mettre en place une base de données à partir d\'un cahier des charges client',
          projects: [
            {name: 'Stage GAGNE', url: '/stage'}
          ]
        },
        {
          code: 'UE3.4',
          description: 'Optimiser une base de données, interagir avec une application et mettre en œuvre la sécurité',
          projects: []
        },
      ]
    },
    {
      competence: 5,
      title: "Conduite de Projet",
      description: "Conduire un projet",
      color: '#5770be',
      icon: 'mdi-timeline-check',
      children: [
        {
          code: 'UE1.5',
          description: 'Identifier les besoins métiers des clients et des utilisateurs',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Stage GAGNE', url: '/stage'}
          ]
        },
        {
          code: 'UE3.5',
          description: 'Appliquer une démarche de suivi de projet en fonction des besoins métiers des clients et des utilisateurs',
          projects: [
            {name: 'NDI 2025', url: '/ndi'}
          ]
        },
      ]
    },
    {
      competence: 6,
      title: "Travail d'Équipe",
      description: "Collaborer au sein d'une équipe informatique",
      color: '#a26859',
      icon: 'mdi-account-group',
      children: [
        {
          code: 'UE1.6',
          description: 'Identifier ses aptitudes pour travailler dans une équipe',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Code Game Jam', url: '/cgj'},
            {name: 'SAE Referendum', url: '/referendum'}
          ]
        },
        {
          code: 'UE3.6',
          description: 'Situer son rôle et ses missions au sein d\'une équipe informatique',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Code Game Jam', url: '/cgj'},
            {name: 'SAE Referendum', url: '/referendum'}
          ]
        },
        {
          code: 'UE5.6',
          description: 'Manager une équipe informatique',
          projects: [
            {name: 'NDI 2025', url: '/ndi'}
          ]
        },
      ]
    },
  ];

  competencesS6 = [
    {
      competence: 1,
      title: "Réaliser (Niveau 3)",
      description: "Adapter des applications sur un ensemble de supports",
      color: '#d08a77',
      icon: 'mdi-code-braces',
      children: [
        {
          code: 'AC 3',
          description: 'Intégrer des solutions dans un environnement de production',
          projects: [
            {name: 'Home Lab', url: '/homelab'},
            {name: 'SAE Cloud Infra', url: '/sae-infra'}
          ]
        },
        {
          code: 'CE1.01',
          description: 'Respecter les besoins décrits par le client',
          projects: [
            {name: 'Stage GAGNE', url: '/stage'}
          ]
        },
        {
          code: 'CE1.04',
          description: 'Veiller à la qualité du code et à sa documentation',
          projects: [
            {name: 'Home Lab', url: '/homelab'},
            {name: 'PikuTrade', url: '/pikutrade'}
          ]
        }
      ]
    },
    {
      competence: 3,
      title: "Administrer (Niveau 3)",
      description: "Faire évoluer et maintenir un système informatique communicant",
      color: '#fdcf41',
      icon: 'mdi-server-network',
      children: [
        {
          code: 'AC 1',
          description: 'Créer des processus de traitement automatisé (IaC, CI/CD)',
          projects: [
            {name: 'SAE Cloud Infra', url: '/sae-infra'},
            {name: 'Home Lab', url: '/homelab'}
          ]
        },
        {
          code: 'AC 2',
          description: 'Configurer un serveur et des services réseaux de manière avancée',
          projects: [
            {name: 'SAE Cloud Infra', url: '/sae-infra'},
            {name: 'Home Lab', url: '/homelab'}
          ]
        },
        {
          code: 'AC 3',
          description: 'Appliquer une politique de sécurité au niveau de l’infrastructure',
          projects: [
            {name: 'SAE Cloud Infra', url: '/sae-infra'},
            {name: 'SAE Referendum', url: '/referendum'}
          ]
        },
        {
          code: 'CE3.04',
          description: 'Assurer la continuité d’activité (PCA/PRA)',
          projects: [
            {name: 'SAE Cloud Infra', url: '/sae-infra'}
          ]
        }
      ]
    },
    {
      competence: 6,
      title: "Collaborer (Niveau 3)",
      description: "Manager une équipe informatique",
      color: '#a26859',
      icon: 'mdi-account-group',
      children: [
        {
          code: 'AC 1',
          description: 'Organiser et partager une veille numérique',
          projects: [
            {name: 'Home Lab', url: '/homelab'}
          ]
        },
        {
          code: 'AC 4',
          description: 'Accompagner le management de projet informatique',
          projects: [
            {name: 'NDI 2025 (Lead Tech)', url: '/ndi'}
          ]
        },
        {
          code: 'CE6.04',
          description: 'Développer une communication efficace et collaborative',
          projects: [
            {name: 'NDI 2025', url: '/ndi'},
            {name: 'Code Game Jam', url: '/cgj'}
          ]
        }
      ]
    }
  ];

  get currentCompetences() {
    return this.activeTab === 's5' ? this.competencesS5 : this.competencesS6;
  }
}
</script>

<template>
  <div class="competences-container">
    <!-- Header -->
    <header class="competences-header">
      <h1>Mes Compétences</h1>
      <p class="subtitle">Un aperçu de mon évolution technique et méthodologique</p>
    </header>

    <!-- Tabs -->
    <div class="tabs-container">
      <button 
        class="tab-btn" 
        :class="{ active: activeTab === 's5' }" 
        @click="activeTab = 's5'"
      >
        <i class="mdi mdi-numeric-5-box-outline"></i>
        <span>Semestre 5</span>
      </button>
      <button 
        class="tab-btn" 
        :class="{ active: activeTab === 's6' }" 
        @click="activeTab = 's6'"
      >
        <i class="mdi mdi-numeric-6-box-outline"></i>
        <span>Semestre 6</span>
      </button>
    </div>

    <!-- Competences Grid -->
    <div class="competences-grid">
      <div
          v-for="(competence, index) in currentCompetences"
          :key="index + activeTab"
          class="competence-card"
          :style="{ '--competence-color': competence.color }"
      >
        <!-- Card Header -->
        <div class="competence-card-header">
          <div class="competence-icon">
            <i :class="competence.icon"></i>
          </div>
          <div class="competence-title-section">
            <div class="competence-badge">Compétence {{ competence.competence }}</div>
            <h2>{{ competence.title }}</h2>
            <p class="competence-description">{{ competence.description }}</p>
          </div>
        </div>

        <!-- Card Content -->
        <div class="competence-card-content">
          <div
              v-for="(child, childIndex) in competence.children.filter(c => c.projects.length > 0)"
              :key="childIndex"
              class="apprentissage-item"
          >
            <div class="apprentissage-header">
              <span class="apprentissage-code">{{ child.code }}</span>
              <p class="apprentissage-desc">{{ child.description }}</p>
            </div>

            <div class="projects-list">
              <router-link
                  v-for="(project, pIndex) in child.projects"
                  :key="pIndex"
                  :to="project.url"
                  class="project-chip"
              >
                <i class="mdi mdi-folder-open-outline"></i>
                <span>{{ project.name }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.competences-container {
  font-family: 'Inter', 'Segoe UI', sans-serif;
  line-height: 1.8;
  color: var(--text-color);
  background-color: var(--background-color);
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 40px;
  padding-left: 120px;
  min-height: 100vh;
}

/* Header */
.competences-header {
  text-align: center;
  margin-bottom: 40px;
}

.competences-header h1 {
  font-size: 3.5em;
  font-weight: 800;
  color: var(--h1-color);
  margin: 0 0 16px 0;
  background: linear-gradient(135deg, #ffffff 0%, var(--tertiary-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 1.2em;
  color: var(--sub-color);
  max-width: 600px;
  margin: 0 auto;
}

/* Tabs */
.tabs-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 30px;
  background: var(--dark-bg-secondary);
  border: 1px solid var(--dark-border);
  border-radius: 16px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1em;
  font-weight: 600;
}

.tab-btn i {
  font-size: 1.4em;
}

.tab-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  background: rgba(19, 124, 139, 0.05);
}

.tab-btn.active {
  background: var(--primary-color);
  color: #ffffff;
  border-color: var(--primary-color);
  box-shadow: 0 4px 15px rgba(19, 124, 139, 0.4);
}

/* Competences Grid */
.competences-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 32px;
}

/* Competence Card */
.competence-card {
  background: var(--card-background);
  border-radius: 24px;
  border: 2px solid var(--dark-border);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
}

.competence-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, var(--competence-color) 0%, transparent 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.competence-card:hover {
  transform: translateY(-8px);
  border-color: var(--competence-color);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px var(--competence-color);
}

.competence-card:hover::before {
  opacity: 1;
}

/* Card Header */
.competence-card-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 32px;
  background: linear-gradient(135deg, var(--dark-bg-secondary) 0%, var(--card-background) 100%);
  border-bottom: 2px solid var(--dark-border);
}

.competence-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  background: linear-gradient(135deg, var(--competence-color) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.competence-card:hover .competence-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 24px var(--competence-color);
}

.competence-icon i {
  font-size: 40px;
  color: #ffffff;
}

.competence-title-section {
  flex: 1;
}

.competence-badge {
  display: inline-block;
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--competence-color);
  border-radius: 20px;
  font-size: 0.75em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 12px;
  border: 1px solid var(--competence-color);
}

.competence-title-section h2 {
  font-size: 1.8em;
  font-weight: 700;
  color: var(--h2-color);
  margin: 0 0 8px 0;
}

.competence-description {
  font-size: 1em;
  color: var(--text-muted);
  margin: 0;
}

/* Card Content */
.competence-card-content {
  padding: 28px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Apprentissage Item */
.apprentissage-item {
  padding: 20px;
  background: var(--dark-bg-secondary);
  border-radius: 16px;
  border-left: 4px solid var(--competence-color);
  transition: all 0.3s ease;
}

.apprentissage-item:hover {
  background: var(--dark-bg-card);
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.apprentissage-header {
  margin-bottom: 16px;
}

.apprentissage-code {
  display: inline-block;
  padding: 6px 12px;
  background: var(--competence-color);
  color: #ffffff;
  border-radius: 8px;
  font-size: 0.85em;
  font-weight: 700;
  margin-bottom: 8px;
}

.apprentissage-desc {
  font-size: 1em;
  color: var(--text-color);
  margin: 8px 0 0 0;
  line-height: 1.6;
}

/* Projects List */
.projects-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.project-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--dark-border);
  border-radius: 12px;
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.3s ease;
}

.project-chip i {
  font-size: 16px;
}

.project-chip:hover {
  background: var(--competence-color);
  color: #ffffff;
  border-color: var(--competence-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Responsive */
@media (max-width: 1200px) {
  .competences-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .competences-container {
    padding: 40px 20px;
    padding-left: 20px;
  }

  .competences-header h1 {
    font-size: 2.5em;
  }

  .competence-card-header {
    flex-direction: column;
    text-align: center;
  }

  .competence-icon {
    margin: 0 auto;
  }

  .competences-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .apprentissage-item {
    padding: 16px;
  }
}
</style>